import * as React from "react";
import { ScrollView } from "react-native";
import { Block } from "@block";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import { StackActions, useNavigation } from "@react-navigation/native";
import ScreenNameType from "@navigation/nav-screens";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { StepProcessUniversal } from "app/shared/components/stepper-process/stepper-process";
import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
import { fetchBillingAuthorizationRequest, setBillingStore } from "../reducer/actions";
import { getBillingStoreSelector } from "../reducer/selectors";
import ConfirmOTP from "app/shared/components/otp/otp";
import { ServiceCode } from "app/shared/services/api-path";
import { pushAppFlyer, pushCleverTapEvent } from "app/shared/util/app-flyer";
import { getContactIdSelector } from "app/modules/account-management/reducer/selectors";

const BillingsAuth = () => {
  const { dispatch } = useNavigation();
  const { t } = useTranslation();
  const dispatchStore = useDispatch();

  const billingStore = useSelector(getBillingStoreSelector);
  const contactId = useSelector(getContactIdSelector);

  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => {
        eventPushCleverTap(undefined, undefined, "cancel");
        dispatch(StackActions.replace(ScreenNameType.HOME));
      },
    },
    {
      name: t("FUNC_DV_THANH_TOAN"),
      onPressSubtitle: () => {
        eventPushCleverTap(undefined, undefined, "cancel");
        dispatch(StackActions.replace(ScreenNameType.LIST_PAYMENTS));
      },
    },
    {
      name: t("FUNC_DV_THANH_TOAN_HOA_DON"),
      onPressSubtitle: () => {},
    },
  ];

  /// MARK: - ACTION
  const onPressCancel = () => {
    const { eventName, params } = handlerParamsAppFlyer(false);
    pushAppFlyer(eventName, params);
    eventPushCleverTap(undefined, undefined, "cancel");
    dispatchStore(setBillingStore({ ...billingStore, isCreated: false, isConfirm: false, errorOTP: false }));
    dispatch(StackActions.replace(ScreenNameType.BILLINGS_CREATE, { resetData: true }));
  };

  const onSubmit = ({ otpCode = "" }) => {
    dispatchStore(fetchBillingAuthorizationRequest(billingStore.responseConfirm, otpCode));
  };

  const handlerParamsAppFlyer = (success: boolean) => {
    console.log("handlerParamsAppFlyer");
    const param = {
      customer_number: billingStore.dataCreate?.INQUIRY_CODE,
      provider: billingStore.dataCreate?.PROVIDER?.label,
      amount: billingStore.responseCreate?.TRANSFER?.CREDIT_AMOUNT,
      fee: "0",
    };
    const paramStatus = {
      success: success,
      failure: !success,
    };
    return {
      eventName: "af_pay_bill",
      params: {
        af_pay_bill_service: billingStore.dataCreate?.SERVICE?.label,
        af_channel: "ib_rb",
        af_pay_bill_info: JSON.stringify(param),
        af_pay_bill_status: JSON.stringify(paramStatus),
      },
    };
  };

  const eventPushCleverTap = (status?: boolean, response?: string, action?: string) => {
    const { eventNameCT, paramsCT } = handlerParamsCleverTap(status, response, action);
    pushCleverTapEvent(eventNameCT, paramsCT);
  };

  const handlerParamsCleverTap = (status?: boolean, response?: string, action?: string) => {
    console.log("handlerParamsCleverTap");
    let param = {};
    param = {
      ct_channel: "ib_rb",
      ct_cccd_ID: contactId,
      ct_billing_type: "billing_payment", //top_up | billing_payment | auto_topup | auto_billing
      ct_billing_service: billingStore.dataCreate?.SERVICE?.label,
      ct_billing_provider: billingStore.dataCreate?.PROVIDER?.label,
      ct_billing_phone: billingStore.dataCreate?.INQUIRY_CODE,
      ct_billing_amount: billingStore.responseCreate?.TRANSFER?.DEBIT_AMOUNT,
      ct_billing_fee: billingStore.responseCreate?.TRANSFER?.TOTAL_FEE_AMOUNT,
      ct_transaction_session: billingStore.responseAuth?.EBINQUIRY?.RQSTSEQ,
      ct_button: action || "", // fee_detail | beneficiary | continue | cancel | back
      ct_error_message: status === false ? response || "" : "",
    };
    if (status !== undefined) {
      param = {
        ...param,
        ct_billing_validate_otp_status: status ? "success" : "failure",
      };
    }

    return {
      eventNameCT: "ct_validate_otp",
      paramsCT: param,
    };
  };

  React.useEffect(() => {
    if (billingStore.isAuthorization) {
      const { eventName, params } = handlerParamsAppFlyer(true);
      pushAppFlyer(eventName, params);
      dispatch(StackActions.replace(ScreenNameType.BILLINGS_SUCCESS));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [billingStore.isAuthorization, dispatch]);

  React.useEffect(() => {
    if (billingStore.errorOTP === true) {
      const { eventName, params } = handlerParamsAppFlyer(false);
      pushAppFlyer(eventName, params);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [billingStore.errorOTP]);

  React.useEffect(() => {
    if (billingStore.statusAuth === "error") {
      eventPushCleverTap(false, "failure" + (billingStore.errorMsg || ""), "continue");
    } else if (billingStore.statusAuth === "ok") {
      eventPushCleverTap(true, "success" + (billingStore.errorMsg || ""), "continue");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [billingStore.statusAuth]);

  return (
    <Block flex={1}>
      <ScrollView>
        <HeaderNav />
        <NavTitleBar title={t("FUNC_DV_THANH_TOAN_HOA_DON")} subtitles={subtitlesArrays} />
        <StepProcessUniversal currentSteps={2} />
        <ConfirmOTP
          goBack={onPressCancel}
          onSubmit={onSubmit}
          data={billingStore.responseConfirm}
          serviceCode={ServiceCode.PAYMENT_BILLING}
          isReset={billingStore.isAuthorization}
          errorEndOTP={billingStore.errorOTP}
        />
      </ScrollView>
    </Block>
  );
};
export default BillingsAuth;
